import React, { useEffect, useState } from 'react';

export default function RegistrationStatus({ status, isEnded })

{
	const [ registrationStatus, setregistrationStatus ] = useState('');

	useEffect(() =>
	{
		console.log('sessionStorage.getItem', sessionStorage.getItem('approvalStatus'));

		setregistrationStatus(sessionStorage.getItem('approvalStatus'));
	}, []);

	return (

		<div className='flexCol textCntr aCntr jCntr'>
			{ isEnded ? <>
				<div className='flexInline pdngVMD'>
					<img src='/icons/timeup.svg' alt='approved' className='timeout' />
				</div>
				<span className='thanksSpan pdngVMD'>Registration Closed</span>
				<span className='thanksDetails'>Registration is no longer available as the webinar has concluded.</span>
			</> : <>
				<div className='flexInline pdngVMD'>
					<img src={registrationStatus === 'Approved' ? '/images/approved.svg' : '/images/pending.svg'} alt='approved' className='thanksImg' />
				</div>
				<span className='thanksSpan pdngVMD'>{registrationStatus === 'Approved' ? 'Thanks for registering' : 'Pending for approval'}</span>
				<span className='thanksDetails'>{registrationStatus === 'Approved' ? 'The details for joining webinar have been sent to your email address' : 'You will recieve an email regarding your registration status'}</span>
			</>
			}
		</div>
	);
}
